module.exports = __webpack_public_path__ + "img/hair_color_fairHaired.06c8e1d.svg";